import { Link } from 'react-router-dom';

import { BannerWithIcon } from '@/components/BannerWithIcon';
import HubIconLarge from '@/icons/HubIconLarge.svg?react';
import { appHubIndexPath } from '@/utils/constants';

function BrowsePublicPromptsButton({
  organizationId,
}: {
  organizationId?: string;
}) {
  return (
    <BannerWithIcon
      icon={
        <HubIconLarge className="absolute left-0 top-0 h-5 w-5 text-brand-green-400" />
      }
      children={
        <div className="my-auto flex flex-row gap-1 text-sm">
          Browse all Public Prompts in the
          <Link
            to={
              organizationId
                ? `/${appHubIndexPath}?organizationId=${organizationId}`
                : `/${appHubIndexPath}`
            }
            className="flex items-center gap-2 font-medium"
          >
            <span className="underline">LangChain Hub</span>
          </Link>
        </div>
      }
      className="bg-opacity-10 text-black dark:text-white"
    />
  );
}

export default BrowsePublicPromptsButton;
